<template>
  <div>
    <ViewCustomData entityName="property_type" entitySpec="data" serviceName="BaseService"
      :columns="PROPERTY_TYPE_DATA_COLUMNS" :dictionary="PROPERTY_TYPE_DATA_DICTIONARY" @selectedRow="onSelectedRow"
      scrollHeight="480px" :paginator="false" mode="edit" :requiredFieldsTable="{
        property_type_sysname: true,
        property_type_class: true,
        property_type_name: true,
      }" :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert" :beforeOpenNewRow="beforeOpenNewRow"
      :prepareData="prepareData" />

    <Panel header="Параметры свойства">
      <div class="formgrid grid">
        <div class="col-10">
          <TabView>
            <TabPanel header="События">
              <PropertyEvent :data="selected" source="property_type_id" v-if="selected && selected.property_type_id > 0"
                nullable="property_id" />
            </TabPanel>
            <TabPanel header="Интерпретация значений">
              <PropertyTypeConversion :propertyType="selected" v-if="selected && selected.property_type_id > 0" />
            </TabPanel>
          </TabView>
        </div>
        <div class="col-2">
          <Textarea v-if="selected" v-model="selected.property_type_desc" rows="12" cols="40" />
        </div>
      </div>
    </Panel>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PropertyEvent from './PropertyEvent.vue'
import PropertyTypeConversion from './PropertyTypeConversion.vue'
import { PROPERTY_TYPE_DATA_DICTIONARY, PROPERTY_TYPE_DATA_COLUMNS, } from './propertyConstants'
import { rtfToTxt } from './rtf_converter.js'

const selected = ref(null);
const passwordReset = ref(false);
const newPassword = ref(null);

const onSelectedRow = (value) => {
  selected.value = value;
}

const convertToRtf = (rtfText) => {
  const plainText = rtfToTxt(rtfText);
  return plainText;
}

const prepareData = (data) => {
  return data.map((item) => ({
    ...item,
    property_type_color:
      item.property_type_color !== null
        ? item.property_type_color.toString(16)
        : 'FFFFFF',
    property_type_ref: Number(item.property_type_ref),
    property_type_desc: item.property_type_desc
      ? convertToRtf(item.property_type_desc)
      : '',
  }));
}

const prepareUpdate = (rowData) => {
  const row = { ...rowData };
  row.property_type_color = row.property_type_color
    ? parseInt(row.property_type_color, 16)
    : null;
  if (selected.value && selected.value.property_type_id === row.property_type_id) {
    row.property_type_desc = selected.value.property_type_desc;
  }
  return row;
}

const prepareInsert = (rowData) => {
  return prepareUpdate(rowData);
}

const beforeOpenNewRow = (rowData) => {
  rowData.property_type_is_visible_form = false;
  rowData.property_type_is_fast = false;
  rowData.property_type_color = 'FFFFFF';
}

</script>

<style lang="scss" scoped>
::v-deep(.p-panel .p-panel-header) {
  padding: 0.5rem;
  border: none;
  background: #84abd6 !important;
  flex-direction: column !important;
}

::v-deep(.p-panel-content) {
  padding: 0.2rem;
}
</style>